'use strict';

angular.module('webAgro1App').directive('agroLegendaMapa', function() {
  return {
    templateUrl: 'views/directives/legenda_mapa.html',
    restrict: 'AE',
    scope: {
      legendas: '=',
      humanize: '=',
      onMouseOver: '&?',
      onMouseOut: '&?',
      printMode: '=?'
    },
    link: function(scope) {
      scope.setCultura = function(cultura) {
        scope.$emit('setCultura', cultura);
      };

      scope.emitMouseover = (legenda) => {
        if (typeof scope.onMouseOver === 'function') {
          scope.onMouseOver({ legenda });
        }
      };

      scope.emitMouseout = (legenda) => {
        if (typeof scope.onMouseOut === 'function') {
          scope.onMouseOut({ legenda });
        }
      };
    }
  };
});
